<template>
	<div style="background: #f3f4f7" v-loading.fullscreen.lock="fullscreenLoading">
		<dialogBox :dialogFlag="fxFlag" @callFn="gbFn" @qrsFn="qrsFn" :title="`您正在创建班级`">
			<el-form :model="ruleForm" ref="ruleForm" :rules="rules" style="width: 430px" label-width="80px">
				<el-form-item label="选择年级" prop="grade">
					<!-- <el-select style="width: 100%" v-model="ruleForm.grade" filterable allow-create default-first-option placeholder="请选择"> -->
					<el-select style="width: 100%" v-model="ruleForm.grade"  placeholder="请选择">
						<el-option v-for="item in njData" :key="item.classificationId" :label="item.classificationName" :value="item.classificationName"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="输入班级" prop="name">
					<el-input v-model="ruleForm.name" placeholder="请输入班级名称" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="班级状态" prop="status">
					<el-radio-group v-model="ruleForm.status">
						<el-radio :label="1">开启</el-radio>
						<el-radio :label="0">关闭</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="班级入驻" prop="addAuditFlag">
					<el-radio-group v-model="ruleForm.addAuditFlag">
						<el-radio :label="1">审核</el-radio>
						<el-radio :label="0">不审核</el-radio>
					</el-radio-group>
				</el-form-item>
			</el-form>
		</dialogBox>
		<userHeader />
		<fuHeader type="2" height="53px" />
		<crumbs :txt="a" type="2" :crumFlag="true" height="53px" />
		<div class="bodyWrapper">
			<div class="gudBtns">
				<div class="gudBtnItem gudBack supHove3" @click="$router.back()">
					<img src="@/assets/img/back.svg" alt="" />
					<span>返回</span>
				</div>
			</div>
			<div class="banjiBox">
				<div class="banjiTab">
					<div class="banjiItem">
						<div class="banjiTip">学校</div>
						<div class="banjiP">
							{{ infoData.school }}
						</div>
						<div class="banjiIcon" @click="infoFn">
							<img src="@/assets/img/xgai.png" alt="" />
							<span>修改归属学校</span>
						</div>
					</div>
					<div class="banjiItem">
						<div class="banjiTip">年级</div>
						<div class="banjiP">
							<span :class="bjVal == '' ? 'active' : ''" @click="tabFn('')">全部</span>
							<span :class="bjVal == item.classificationName ? 'active' : ''" v-for="item in njData" @click="tabFn(item.classificationName)" :key="item.classificationId">
								{{ item.classificationName }}
							</span>
						</div>
						<div class="banjiIcon" @click="fxFlag = true">
							<img src="@/assets/img/cjbj.svg" alt="" />
							<span>创建新班级</span>
						</div>
					</div>
				</div>
				<div class="banjiCont" v-if="bjData.length">
					<div class="banjiCitem" :class="item == 1 ? 'banjiCitemActive' : ''" v-for="item in bjData" :key="item.id" @click="bjtoFn(item.id, item.name, item)">
						<div class="brBox" v-if="item.default">
							<span>默认</span>
						</div>
						<h3>班级：{{ item.name }}</h3>
						<p>
							<img src="@/assets/img/编组 (8).svg" alt="" />
							<span>班号</span>
							{{ item.number }}
						</p>
						<div class="banjiCitemImg">
							<img :src="item.ewUrl" alt="" />
						</div>
						<div class="banjiCitemFot">
							<p>
								<img src="@/assets/img/编组 (9).svg" alt="" />
								<span>班级人数</span>
								{{ item.peopleNumber }}人
							</p>
							<div class="banjiCitemBtn" :class="item.status == 1 ? 'banjiCitemBtn1' : ''">
								{{ item.status == 1 ? '开启' : '关闭' }}
							</div>
						</div>
					</div>
				</div>
				<div class="banjiCont1" v-if="!bjData.length">
					<el-empty description="暂无班级"></el-empty>
				</div>
			</div>
		</div>
		<foot />
	</div>
</template>

<script>
import foot from '@/components/foot/foot';
import userHeader from '@/components/hearder/userHeader';
import fuHeader from '@/components/hearder/fuHeader';
import dialogBox from '@/components/pubComponents/dialogBox';
import { mapState } from 'vuex';

export default {
	name: 'myBanji',
	data() {
		return {
			fxFlag: false,
			ruleForm: {
				grade: '',
				name: '',
				status: '',
				addAuditFlag: ''
			},
			rules: {
				grade: [{ required: true, message: '请选择年级', trigger: 'change' }],
				name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
				status: [{ required: true, message: '请选择班级状态', trigger: 'change' }],
				addAuditFlag: [{ required: true, message: '请选择班级入住', trigger: 'change' }]
			},
			bjVal: '',
			options: [],
			njData: [],
			bjData: [],
			fullscreenLoading: false,
			a: [],
		};
	},
	components: {
		userHeader,
		dialogBox,
		fuHeader,
		foot
	},
	computed: {
		...mapState(['infoData'])
	},
	methods: {
		ewmaFn(id) {
			return new Promise((resolve, reject) => {
				let url = '';
				// 班级二维码
				url = `pages/home/a_resources/resources-search-list?id=${id}`;
				this.$http
					.get('api/app/common/getMiniProgramsCodes', {
						params: {
							url,
							clientType: '1'
						},
						responseType: 'blob'
					})
					.then((res) => {
						if (res) {
							const blob = new Blob([res], { type: 'image/png' });
							resolve(URL.createObjectURL(blob));
						}
					});
			});
		},
		infoFn() {
			this.$store.commit('setCachedComponents', '');
			setTimeout(() => {
				this.$store.commit('setCachedComponents', 'myInfo');
			}, 1000);
			this.$router.push({
				path: 'myInfo',
				query: {}
			});
		},
		tabFn(val) {
			this.bjVal = val;
			this.bjInfo();
		},
		qrsFn() {
			this.$refs['ruleForm'].validate((valid) => {
				if (valid) {
					console.log(this.ruleForm, '22222233');
					let set = this.$loading(this.$pre);
					this.$http
						.post('api/app/yydBj', {
							...this.ruleForm
						})
						.then((res) => {
							set.close();
							if (res.code == 200) {
								this.$message({
									message: '创建成功',
									type: 'success'
								});
								this.gbFn();
								this.init();
							}
						});
				}
			});
		},
		gbFn() {
			this.fxFlag = false;
			this.$refs.ruleForm.clearValidate();
			this.$refs.ruleForm.resetFields();
		},
		bjtoFn(id, name, item) {
			if (item.regulatoryFlag) {
				this.$message({
					message: '该班级已被监管，请联系工作人员~',
					type: 'warning'
				});
				return;
			}
			this.$router.push({
				name: 'banjiHome',
				query: {
					id,
					txt: name
				},
				params: {
					sxStatus: 1,
				}
			});
		},
		init() {
			this.fullscreenLoading = true;
			this.$http.get(`api/app/yydExaminationQuestionClassification/selectList/1`).then((res) => {
				this.fullscreenLoading = false;
				if (res.code == 200) {
					this.njData = res.data;
				}
			});
			this.bjInfo();
		},
		bjInfo() {
			this.fullscreenLoading = true;
			this.$http
				.get('api/app/yydBj/list', {
					params: {
						grade: this.bjVal
					}
				})
				.then(async (res) => {
					this.fullscreenLoading = false;
					res.rows.forEach(async (item) => {
						let url = await this.ewmaFn(item.id);
						this.$set(item, 'ewUrl', url);
					});
					console.log(res);
					this.bjData = res.rows || [];
				});
		}
	},
	mounted() {
		let { cjFlag, txt, tabFtxt } = this.$route.query;
		if (tabFtxt) {
			this.a = typeof tabFtxt == 'string' ? [tabFtxt] : [...tabFtxt];
		}
		if (this.txt?.includes('~')) {
			this.a.push(...this.txt?.split('~'));
		} else {
			this.a.push(this.txt);
		}
		if (cjFlag) {
			this.fxFlag = true;
		}
		this.init();
	}
};
</script>
<style lang="scss" scoped>
.banjiBox {
	width: 1200px;
	min-height: calc(100vh - 394px);
	margin: 0 auto;
	.banjiCont1 {
		margin-bottom: 10px;
		background: #ffffff;
		border-radius: 6px;
		min-height: 400px;
	}
	.banjiCont {
		margin-bottom: 10px;
		background: #ffffff;
		border-radius: 6px;
		padding: 25px 30px 1px;
		display: flex;
		flex-wrap: wrap;
		.banjiCitem {
			background: #ffffff;
			box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.11);
			border-radius: 6px;
			border: 1px solid #dee0e3;
			margin: 0 24px 30px 0;
			width: calc((100% - 96px) / 5);
			box-sizing: border-box;
			padding: 13px 7px 16px;
			position: relative;
			cursor: pointer;
			.brBox {
				position: absolute;
				top: 0;
				right: 0;
				width: 55px;
				height: 55px;
				background: #1d7b3a;
				color: #fff;
				font-size: 12px;
				border-top-right-radius: 6px;
				clip-path: polygon(0% 0%, 100% 100%, 100% 0%, 0% 0%);
				span {
					position: absolute;
					top: 10px;
					right: 4px;
					transform: rotate(45deg);
				}
			}

			.banjiCitemBtn {
				position: absolute;
				color: #a9a9a9;
				right: 7px;
				bottom: 17px;
				font-size: 12px;
				&::before {
					content: '';
					width: 5px;
					height: 5px;
					background: #7f7f7f;
					border-radius: 50%;
					position: absolute;
					left: -10px;
					top: 50%;
					transform: translateY(-50%);
				}
			}
			.banjiCitemBtn1 {
				color: #1d7b3a;
				&::before {
					background: #1d7b3a;
				}
			}

			&:nth-of-type(5n) {
				margin-right: 0;
			}
			h3 {
				font-size: 14px;
				color: #000000;
				margin-bottom: 10px;
				padding-left: 13px;
				font-weight: bold;
			}
			p {
				display: flex;
				padding-left: 13px;
				align-items: center;
				font-size: 14px;
				color: #000000;
				margin-bottom: 19px;
				img {
					width: 15px;
					height: 14px;
					margin-right: 9px;
				}
				span {
					color: #a9a9a9;
					margin-right: 5px;
				}
			}
			.banjiCitemImg {
				text-align: center;
				margin-bottom: 15px;
				img {
					width: 150px;
					height: 150px;
				}
			}
			.banjiCitemFot {
				p {
					margin: 0;
					padding-left: 5px;
				}
			}
		}
		.banjiCitemActive {
			.banjiCitemBtn {
				color: #1d7b3a;
				&::before {
					background: #1d7b3a;
				}
			}
		}
	}
	.banjiTab {
		background: #ffffff;
		border-radius: 6px;
		margin: 10px 0 10px;
		padding: 21px 20px;
		.banjiItem {
			display: flex;
			margin-bottom: 20px;
			align-items: center;
			&:last-of-type {
				margin: 0;
			}
			.banjiTip {
				width: 65px;
				color: #a1a1a1;
			}
			.banjiP {
				font-size: 14px;
				color: #000000;
				display: flex;
				span {
					margin-right: 40px;
					cursor: pointer;
					&:last-of-type {
						margin-right: 0;
					}
				}
				.active {
					color: #1d7b3a;
				}
			}
			.banjiIcon {
				margin-left: 18px;
				display: flex;
				align-items: center;
				color: #1d7b3a;
				font-size: 14px;
				cursor: pointer;
				img {
					width: 13px;
					height: 13px;
					margin-right: 7px;
				}
			}
		}
	}
}
</style>
